
<template>   
    <router-view></router-view>  
</template>
 
<script lang="ts">
	 
    import { Options, Vue  } from "vue-class-component";  
     
    @Options({
        name: "Instrutor",
        components: {    },  
    }) 
    export default class Instrutor extends Vue {
         
    }
  
</script>
  